import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { PAGINATION_DEFAULT } from '../../../utils/constants'
import DashboardLayout from '../../../components/layouts/dashboard'
import UnauthorizedPage from '../../errors/unauthorized'
import PastAnnouncements from './PastAnnouncements'
import ScheduledAnnouncements from './ScheduledAnnouncements'
import TabView from '../../../components/tabview'
import Button from '../../../components/button'
import SendAnnouncement from '../dashboard/SendAnnouncement'

const HRAnnouncementPage = () => {
  const { user } = useSelector((state) => state.userSlice)
  const [unauthorized, setUnauthorized] = useState(false)
  const [announcement, setAnnouncement] = useState(false)

  useEffect(() => {
    if (user) {
      if (user.permissions.company_permission.role !== 'Owner') {
        if (user.permissions.company_permission.promotion_read !== 1) {
          setUnauthorized(true)
        }
      }
    }
  }, [user])

  const [activeTab, setActiveTab] = useState(1)

  const AnnouncementsTabs = [
    {
      title: 'Past Announcements',
      Content:
        user?.permissions.training_permission.training_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? PastAnnouncements
          : UnauthorizedPage,
    },
    {
      title: 'Scheduled Announcements',
      Content:
        user?.permissions.training_permission.trainer_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? ScheduledAnnouncements
          : UnauthorizedPage,
    },
  ]

  return (
    <DashboardLayout title='Announcements'>
      {unauthorized ? (
        <UnauthorizedPage />
      ) : (
        <>
          {announcement && (
            <SendAnnouncement
              isOpen={announcement}
              closeModal={() => setAnnouncement(false)}
            />
          )}
          <div className='flex flex-col bg-white p-3 border rounded'>
            <div className='flex flex-col md:flex-row justify-start md:items-center items-start md:justify-between gap-3 '>
              <p className='text-base font-semibold'>Announcements</p>
              <div className='w-fit'>
                <Button
                  text='Create New Announcement'
                  type='button'
                  theme='primary'
                  className='flex gap-2 !h-[35px] w-fit px-2 items-center'
                  textClass={'!text-[11px]'}
                  leftIcon={'add'}
                  onClick={() => {
                    setAnnouncement(true)
                  }}
                />
              </div>
            </div>
            <div className='mt-4'>
              <TabView
                Tabs={AnnouncementsTabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  )
}

export default HRAnnouncementPage
